const ERROR_MESSAGES = {
    API_ERROR: "Oops! Something went wrong. Please contact Pierse Fitzgibbon Solicitors for more information.<br /><i>Úps! Chuaigh rud eigin mícheart. Déan teagmháil le Pierse Fitzgibbon Solicitors le do thoil le haghaidh tuilleadh eolais</i>",
    NO_CASE_NUMBER: "Please enter a case number<br><i>Cuir isteach uimhir cháis</i>",
    INVALID_CASE_NUMBER: "Please enter a valid reference number, e.g. U1234567890 or U12-3456-7890<BR><I>Cuir isteach uimhir thagartha bailí le do thoil, m.sh. U1234567890 nó U12-3456-7890</I>"
}

export default ERROR_MESSAGES;